import { MEMBER_RANKINGS_IDS } from '@/modules/players/v2/tabs/constants';
import { RenderedPlayerClubsData } from '@/types/clubs.types';
import { FavoriteClubModule } from '@/types/favoritesClubs.types';

export const isMemberRankingsClubID = (clubID: string) => {
  return MEMBER_RANKINGS_IDS.includes(clubID);
};

export const mapFavoriteClubsData = (
  favoriteClubs: FavoriteClubModule[]
): RenderedPlayerClubsData[] => {
  if (favoriteClubs.length === 0) return [];

  const favoriteClubsModified: RenderedPlayerClubsData[] =
    favoriteClubs?.map((org) => {
      const { moduleData } = org;

      const orgLogo =
        moduleData?.organizationLogos?.find(
          (logo) => !logo.dateDisabled && logo.url && logo.isPrimary
        )?.url ||
        moduleData?.organizationLogos?.[0]?.url ||
        '';

      const primaryLocation = moduleData?.locations?.find((location) => location.isPrimary);

      return {
        uuid: moduleData.uuid,
        slug: moduleData.slug,
        title: moduleData.title,
        totalTournaments: moduleData.totalTournaments || '0',
        totalLeagues: moduleData.totalLeagues || '0',
        venue: primaryLocation?.venue || '',
        address: primaryLocation?.streetAddress || '',
        city: primaryLocation?.city || '',
        state: moduleData?.stateInfo?.abbreviation || '',
        zip: primaryLocation?.zip || '',
        country: moduleData.countryInfo?.abbreviation || '',
        memberCount: moduleData.memberCount || '0',
        logo: orgLogo,
        agreedToAllWaivers: moduleData.agreedToAllWaivers,
        isFavourite: true,
        showToPublic: moduleData.showToPublic,
      };
    }) || [];

  return favoriteClubsModified;
};
